'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ensureExtension;

var _pathBrowserify = require('path-browserify');

var _pathBrowserify2 = _interopRequireDefault(_pathBrowserify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ensureExtension(filePath) {
  if (!_pathBrowserify2.default.extname(filePath)) {
    return filePath + '.js';
  } else {
    return filePath;
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/codesandboxer/dist/fetchFiles/ensureExtension.js
// module id = 419
// module chunks = 168707334958949